import { createReducer, on } from '@ngrx/store';
import { returnRequest, sendRequest } from './http-status.actions';

export const initialState = 0;

const _httpRequestCountReducer = createReducer(
  initialState,
  on(sendRequest, httpRequestCount => httpRequestCount + 1),
  on(returnRequest, httpRequestCount => httpRequestCount - 1),
);

// eslint-disable-next-line func-style
export function httpRequestCountReducer(state, action) {
  return _httpRequestCountReducer(state, action);
}
